import {
  Modal,
  Button,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ButtonGroup,
  Text
} from '@homebotapp/hb-react-component-catalog'
import { defineMessages, useIntl } from 'react-intl'

const MSG = defineMessages({
  manageAlerts: {
    id: 'GalleryAlertOptInModal.manageAlerts',
    defaultMessage: 'Manage alerts'
  },
  doYouWantToGetEmailsAboutNewAndInterestingListingsInYourFavoriteMarkets: {
    id: 'GalleryAlertOptInModal.doYouWantToGetEmailsAboutNewAndInterestingListingsInYourFavoriteMarkets',
    defaultMessage: 'Do you want to get emails about new and interesting listings in your favorite markets?'
  },
  youCanAdjustTheseSettingsAnyTime: {
    id: 'GalleryAlertOptInModal.youCanAdjustTheseSettingsAnyTime',
    defaultMessage: 'You can adjust these settings any time.'
  },
  yes: {
    id: 'General.yes',
    defaultMessage: 'Yes'
  },
  no: {
    id: 'General.no',
    defaultMessage: 'No'
  }
})

interface GalleryAlertOptInModalProps {
  isOpen: boolean
  updateDefaultGalleryAlertPreference: (boolean) => void
}

export const GalleryAlertOptInModal = ({
  isOpen,
  updateDefaultGalleryAlertPreference
}: GalleryAlertOptInModalProps) => {
  const intl = useIntl()
  if (!isOpen) {
    return null
  }

  return (
    <Modal isOpen={isOpen} onClose={() => null}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>
          <Text color='neutral.900' fontWeight='semibold'>
            {intl.formatMessage(MSG.manageAlerts)}
          </Text>
        </ModalHeader>
        <ModalBody>
          <Text color='neutral.700' fontWeight='bold'>
            {intl.formatMessage(MSG.doYouWantToGetEmailsAboutNewAndInterestingListingsInYourFavoriteMarkets)}
          </Text>
          <Text color='neutral.700'>{intl.formatMessage(MSG.youCanAdjustTheseSettingsAnyTime)}</Text>
        </ModalBody>
        <ModalFooter>
          <ButtonGroup gap={4} width='100%'>
            <Button colorScheme='secondary' onClick={() => updateDefaultGalleryAlertPreference(false)} width='100%'>
              {intl.formatMessage(MSG.no)}
            </Button>
            <Button colorScheme='primary' onClick={() => updateDefaultGalleryAlertPreference(true)} width='100%'>
              {intl.formatMessage(MSG.yes)}
            </Button>
          </ButtonGroup>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}
